import { addGoodsCart, getGoodsCart } from "@/api/goods";
import local from "@/utils/local";

const state = {
  isFromClassifyClick: 0,
  shoppingCart: [], // 购物车
  newShoppingCart: [], // 刚加入的购物车，作为展示
  orderInfo: local.get("orderInfo") ? JSON.parse(local.get("orderInfo")) : [], // 支付流程中确认订单的订单信息
  confirmOrder: local.get("confirmOrder")
    ? JSON.parse(local.get("confirmOrder"))
    : {}, // 支付点击购物车结算下一步的数据
  rightRefresh: 0 //右侧购物车刷新  次数递增就会触发刷新
};

const mutations = {
  SET_FROM_CLICK: (state, isFromClassifyClick) => {
    state.isFromClassifyClick = isFromClassifyClick;
  },
  ADD_SHOPPING_CART: (state, data) => {
    state.shoppingCart.push(data);
    state.newShoppingCart = data;
  },
  SET_SHOPPING_CART: (state, data) => {
    state.shoppingCart = data;
  },
  SET_ORDER_INFO: (state, data) => {
    state.orderInfo = data;
  },
  SET_CONFIRM_ORDER: (state, data) => {
    state.confirmOrder = data;
  },
  SET_RIGHT_REFRESH: (state, data) => {
    state.rightRefresh = data;
  }
};

const actions = {
  setGoodListFrom({ commit }, classifyClick) {
    commit("SET_FROM_CLICK", classifyClick);
  },
  addShoppingCart({ commit }, goods) {
    return new Promise((resolve, reject) => {
      addGoodsCart(goods)
        .then(res => {
          const data = res.data;
          commit("ADD_SHOPPING_CART", goods);
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  loadShoppingCart({ commit }) {
    return new Promise((resolve, reject) => {
      getGoodsCart(goods)
        .then(res => {
          const data = res.data;
          console.log("getGoodsCart111",data)
          commit("SET_SHOPPING_CART", data);

          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setOrderInfo({ commit }, info) {
    commit("SET_ORDER_INFO", info);
    local.set("orderInfo", JSON.stringify(info));
  },
  setConfirmOrder({ commit }, order) {
    commit("SET_CONFIRM_ORDER", order);
    local.set("confirmOrder", JSON.stringify(order));
  },
  setRightRefresh({ commit }, count) {
    commit("SET_RIGHT_REFRESH", count);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/vuex/modules/goods.js